import { pick } from 'lodash';
import { PropertyType } from '../../../common';

export const mapToFormData = (data: PropertyType): PropertyType => {
	const formData = new FormData();
	const keys = Object.keys(data);

	keys.forEach((key) => {
		if (key !== 'filters') {
			formData.append(key, data[key]);
		} else {
			formData.append(key, JSON.stringify(data[key]));
		}
	});
	return formData;
};

export const mapEntityToApi = (data: PropertyType): PropertyType => {
	const { gameForm, token } = data;
	const apiData: PropertyType = {
		sid: token,
	};

	apiData.is_slot = gameForm.is_slot ? '1' : '0';
	apiData.active = gameForm.active ? '1' : '0';
	apiData.internal_game_id = gameForm.internal_game_id;
	if (gameForm.game_name) apiData.game_name = gameForm.game_name;
	if (gameForm.provider_game_id_desktop) apiData.provider_game_id_desktop = gameForm.provider_game_id_desktop;
	if (gameForm.provider_game_id_mobile) apiData.provider_game_id_mobile = gameForm.provider_game_id_mobile;
	if (gameForm.rtp) apiData.rtp = gameForm.rtp;
	if (gameForm.volatility) apiData.volatility = gameForm.volatility;
	if (gameForm.wagering_weight) apiData.wagering_weight = gameForm.wagering_weight;
	if (gameForm.notes) apiData.notes = gameForm.notes;
	// if (gameForm.game_provider_id.length) apiData.game_provider_id = gameForm.game_provider_id[0].value;
	if (gameForm.aams_type_id.length) apiData.aams_type_id = gameForm.aams_type_id[0].value;
	if (gameForm.custom_fields.length)
		apiData.custom_fields = gameForm.custom_fields.map((f: PropertyType) => pick(f, ['name', 'value']));

	return apiData;
};
